<template>
  <v-card>
    <ValidationObserver ref="observer">
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <!-- https://jsfiddle.net/meyubaraj/fLbe7r72/ -->
            <v-col cols="12">
              <v-text-field label="Choisir une image" @click='$refs.image.click()' v-model='imageName' prepend-icon='add_photo_alternate'></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="image"
                accept="image/*"
                @change="onFilePicked"
              >
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="fournisseur" rules="required" v-slot="{ errors }">
                <v-select
                  label="Fournisseur"
                  v-model="item.producer_id"
                  :items="producers"
                  item-text="name"
                  item-value="producer_id"
                  no-data-text="Aucun fournisseur disponible"
                  :error-messages="errors[0]"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="nom" rules="required" v-slot="{ errors }">
                <v-text-field
                  label="Nom"
                  v-model="item.name"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="référence" rules="max:32" v-slot="{ errors }">
                <v-text-field
                  label="Référence"
                  v-model="item.reference"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="température" rules="required|between:7,18" v-slot="{ errors }">
                <v-text-field
                  label="Température de consommation"
                  v-model="item.target_temperature"
                  type="number"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="couleur" rules="required" v-slot="{ errors }">
                <v-select
                  label="Couleur"
                  v-model="item.color"
                  :items="colors"
                  :error-messages="errors[0]"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Région"
                v-model="item.data.region"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Appellation"
                v-model="item.data.appellation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Millésime"
                v-model="item.data.vintage"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Alcohol"
                v-model="item.data.alcohol"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Conseils de consommation"
                v-model="item.data.tasting_advice"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Description (FR)"
                v-model="item.data.description.fr"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Description (EN)"
                v-model="item.data.description.en"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-text>
        {{ error }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dismiss">Annuler</v-btn>
        <v-btn color="blue darken-1" text @click="save">Sauver</v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

import { WINE_CREATE, WINE_UPDATE } from '@/store/actions/wine';
import { PRODUCER_LIST } from '@/store/actions/producer';


export default {
  name: 'WineEdit',

  data () {
    return {
      item: {},

      imageName: '',
      imageForm: null,

      error: '',

      colors: [
        { text: 'Rouge', value: 'red' },
        { text: 'Rosé', value: 'rose' },
        { text: 'Blanc', value: 'white' }
      ]
    };
  },

  computed: {
    ...mapState({
      defaultItem: state => state.wine.defaultItem,
      producers: state => state.producer.producers
    }),
    isNewItem () {
      return !this.item.wine_id;
    },
    dialogTitle () {
      return this.isNewItem ? 'Nouvel élément' : 'Edition';
    }
  },

  created () {
    this.reset();
  },

  mounted () {
    this.$store.dispatch(PRODUCER_LIST);
  },

  methods: {
    edit (_item) {
      this.item = _.merge({}, this.item, this.defaultItem, _item);
    },

    reset () {
      this.item = _.merge({}, this.item, this.defaultItem);
      this.imageName = '';
      this.imageForm = null;

      this.error = '';

      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
    },

    dismiss () {
      this.$emit('dismissed');
      this.reset();
    },

    async save () {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      // Send to Store
      try {
        if (this.isNewItem) {
          await this.$store.dispatch(WINE_CREATE, { data: this.item, label: this.imageForm });
        } else {
          await this.$store.dispatch(WINE_UPDATE, { data: this.item, label: this.imageForm });
        }
      } catch (err) {
        this.error = err;
        return;
      };

      // Close
      this.$emit('saved');

      // Reset the values
      this.reset();
    },

    onFilePicked (event) {
      const files = event.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;

        this.imageForm = new FormData();
        this.imageForm.append('label', files[0], files[0].name);
      } else {
        this.imageName = '';
        this.imageForm = null;
      }
    }
  }
};
</script>
